import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Box,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import leafLeft from "../../Asset/icon/leafLeft.svg";
import leafRight from "../../Asset/icon/leafRight.svg";
import { resetPasswordAction } from "../../redux/Auth/AuthSlice";
import "../../Asset/scss/takemyyacht.scss";

const ResetPasswordModal = ({ verifyId, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const resetPasswordStatus = useSelector(
    (state) => state.AuthSlice.resetPasswordStatus
  );

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setSnackbar({
        open: true,
        message: t("fillAllFields"),
        severity: "error",
      });
      return;
    }
    if (password !== confirmPassword) {
      setSnackbar({
        open: true,
        message: t("passwordsDoNotMatch"),
        severity: "error",
      });
      return;
    }

    try {
      const result = await dispatch(
        resetPasswordAction({ token: verifyId, password })
      );
      if (result.status === "success") {
        setSnackbar({
          open: true,
          message: t("Password reset successful!"),
          severity: "success",
        });
        setTimeout(() => {
          onClose(); 
          navigate("/"); 
        }, 2000);
      } else {
        setSnackbar({
          open: true,
          message: t("Failed to reset password."),
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: t("errorOccurred"),
        severity: "error",
      });
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content2">
        <IconButton className="iconButtonClose" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <div className="d-flex align-items-center centerAlign">
          <img
            className="img-fluid"
            draggable={false}
            src={leafLeft}
            alt="leftImage"
          />
          <h4 className="textColorPrimary m-2">{t("Reset Password")}</h4>
          <img
            className="img-fluid"
            draggable={false}
            src={leafRight}
            alt="rightImage"
          />
        </div>
        <form onSubmit={handleResetPassword}>
          <Box className="boxInputRP">
            <TextField
              className="textField"
              label={t("New Password")}
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              required
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
            />
          </Box>
          <Box>
            <TextField
              className="textField"
              label={t("Confirm Password")}
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              required
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
            />
          </Box>
          <Box>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="buttonSubmit buttonSubmitRP2"
              disabled={resetPasswordStatus === "processing"}
            >
              {resetPasswordStatus === "processing"
                ? t("processing...")
                : t("submit")}
            </Button>
          </Box>
        </form>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ResetPasswordModal;
